import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import {
  BASE_URL,
  BASE_ROLE_URL,
  BASE_ADMIN_URL,
  BASE_PRIVILEGES_URL,
  BASE_PROFILE_URL,
  BASE_COMMON_URL,
} from '../apiConfig';

export const fetchRoleList = async () => {
  const response = await apiClient.get(`${BASE_URL}${BASE_ROLE_URL}/list`);
  return response.data;
};

export const fetchPrivileges = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_PRIVILEGES_URL}/get-by-company-code`,
  );
  return response;
};

export const fetchCompanyList = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_COMMON_URL}/company-list`,
  );
  return response;
};

export const searchRole = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_ROLE_URL}/search`,
    payload,
  );
  return response?.data ?? [];
};

export const getRoleById = async id => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_ROLE_URL}/getById/${id}`,
  );
  return response?.data ?? [];
};

export const saveRole = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_ROLE_URL}/save`,
    payload,
  );
  return response;
};

// Get all the application services execution details
export const fetchExecutionServiceDetails = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_ADMIN_URL}/user-mgmt/process-details`,
  );
  return response;
};

// Execute the application services
export const executeServiceProcess = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_ADMIN_URL}/user-mgmt/execute-service`,
    payload,
  );
  return response;
};

export const fetchUsers = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PROFILE_URL}/search-user`,
    payload,
  );
  return response;
};

export const changeUserPassword = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PROFILE_URL}/change-password`,
    payload,
  );
  return response;
};

export const getByUserId = async userId => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_PROFILE_URL}/get-user-by-id/${userId}`,
  );
  return response;
};

export const updateUserStatus = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PROFILE_URL}/update-user-status`,
    payload,
  );
  return response;
};
